import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormGroup} from "@angular/forms";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "./services/association.service";

@Component({
    selector: 'app-association-detail',
    templateUrl: './association-detail.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationDetailComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    unitBases: any = {};
    conditionTypes: any = {};
    integerLogics: any = {};

    association: any = {};
    activeTab = 'detail';

    constructor(
        injector: Injector,
        private parameterService: ParameterService,
        private associationService: AssociationService,
    ) {
        super(injector);

    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        switch (this.activatedRoute.snapshot.queryParams.tab) {
            case 'detail': this.activeTab = 'detail'; break;
            case 'activities': this.activeTab = 'activities'; break;
            case 'certifications': this.activeTab = 'certifications'; break;
            default: this.activeTab = 'detail'; break;
        }

        this.conditionTypes = await this.parameterService.getParameterByName("CONDITION_TYPE");
        this.integerLogics = await this.parameterService.getParameterByName("INTEGER_LOGICAL_OPERATOR");
        this.unitBases = await this.parameterService.getParameterByName("UNIT_BASE");

        this.association = await this.associationService.getById(this.activatedRoute.snapshot.params.providerId);
    }

    goEdit() {
        this.router.navigate(['/office/association/detail/' + this.activatedRoute.snapshot.params.providerId + '/edit']).then()
    }
}
